import { useState } from 'react';

import { useIsomorphicLayoutEffect } from 'motion/react';

export function useMediaQuery(query: string, initial: boolean = false) {
  const [matches, setMatches] = useState(initial);

  useIsomorphicLayoutEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);
    const onChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };
    mediaQueryList.addEventListener('change', onChange);
    return () => mediaQueryList.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
